import { Schema } from "effect";
import { OpenApiClass } from "../openapi-class.js";

const NullableText = Schema.NullOr(Schema.String);
const NullableInteger = Schema.NullOr(Schema.Int);

/** A source code with an optional label from the matching SCB code table. */
export class LegalEntityCodeLabel extends OpenApiClass<LegalEntityCodeLabel>(
  "LegalEntityCodeLabel"
)({
  code: Schema.String,
  label: NullableText,
}) {}

/** Industry assignment in the source-provided priority order. */
export class LegalEntityIndustryFact extends OpenApiClass<LegalEntityIndustryFact>(
  "LegalEntityIndustryFact"
)({
  code: Schema.String.pipe(Schema.check(Schema.isPattern(/^\d{5}$/u))),
  rank: Schema.Int.pipe(Schema.check(Schema.isGreaterThan(0))),
  percentage: NullableInteger,
  sectionCode: NullableText,
  label: NullableText,
}) {}

/** Allowlisted SCB AFR legal-entity facts; absent source values are represented as null. */
export class LegalEntitySourceFacts extends OpenApiClass<LegalEntitySourceFacts>(
  "LegalEntitySourceFacts"
)({
  source: Schema.Literal("scb_afr"),
  mappingVersion: Schema.Literal(1),
  legalName: NullableText,
  postalAddress: Schema.NullOr(
    Schema.Struct({ street: NullableText, postalCode: NullableText, city: NullableText })
  ),
  seatMunicipality: Schema.NullOr(LegalEntityCodeLabel),
  seatCounty: Schema.NullOr(LegalEntityCodeLabel),
  legalForm: Schema.NullOr(LegalEntityCodeLabel),
  companyStatus: Schema.NullOr(LegalEntityCodeLabel),
  employerStatus: Schema.NullOr(LegalEntityCodeLabel),
  vatStatus: Schema.NullOr(LegalEntityCodeLabel),
  fTaxStatus: Schema.NullOr(LegalEntityCodeLabel),
  bolagsverketStatus: Schema.NullOr(LegalEntityCodeLabel),
  employeeSizeClass: Schema.NullOr(LegalEntityCodeLabel),
  turnoverClass: Schema.NullOr(LegalEntityCodeLabel),
  ownershipControl: Schema.NullOr(LegalEntityCodeLabel),
  publicPrivate: Schema.NullOr(LegalEntityCodeLabel),
  sector: Schema.NullOr(LegalEntityCodeLabel),
  reportedWorkplaceCount: NullableInteger,
  turnoverYear: NullableInteger,
  importExportCode: NullableText,
  activityStartDate: NullableText,
  activityEndDate: NullableText,
  registrationDate: NullableText,
  industryClassification: Schema.Literal("SNI 2025"),
  industries: Schema.Array(LegalEntityIndustryFact),
}) {}
